import React from 'react';
import { School } from 'lucide-react';
import CreateSchoolForm from './CreateSchoolForm';
import { useSchoolActions } from './useSchoolActions';

export default function RequireSchoolModal() {
  const { loading, handleCreateSchool } = useSchoolActions();

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-2xl bg-surface-light rounded-xl shadow-lg overflow-hidden">
        <div className="p-6 border-b border-border-light text-center">
          <div className="w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <School className="w-8 h-8 text-primary-500" />
          </div>
          <h2 className="text-2xl font-semibold text-text-primary">Welcome to Campus Connect</h2>
          <p className="text-text-secondary mt-2">
            Let's get started by creating your school
          </p>
        </div>

        <CreateSchoolForm
          onCancel={() => {}} // No cancel option for initial setup
          onCreate={handleCreateSchool}
          loading={loading}
        />
      </div>
    </div>
  );
}